import * as React from "react";
import SimpleDictionaryFormConfig from "../../components/common/SimpleDictionaryFormConfig";
import { useTranslation } from 'react-i18next';

export const useFormConfig = () => {
    const { t } = useTranslation();
    
    return {
        config: { columns: 1 },
        fields: [
            {
                name: "name",
                label: t("common.name"),
                column: 1,
                mandatory: true,
            },
            {
                name: "fastActingPartCategory",
                label: t("forms.category_name"),
                type: "dictionary",
                dictionary: "fastActingPartCategory",
                dictionaryApi: "fastActingPart/category",
                creationForm: SimpleDictionaryFormConfig(t),
                modalTitle: t("forms.new_category"),
                mandatory: true,
                column: 1,
            },
            {
                name: "minimalQuantity",
                label: t("common.minimal_states"),
                type: "number",
                mandatory: true,
                column: 1,
            },
            {
                name: "quantity",
                label: t("common.current_states"),
                type: "number",
                onlyForReadOnly: true,
                column: 1,
            },
            {
                name: "images",
                label: t("common.photos"),
                type: "file",
                column: 1,
            },
            {
                name: "description",
                label: t("forms.description"),
                type: "textarea",
                column: 1,
            }
        ]
    };
};

export default useFormConfig;
